export default "__VITE_ASSET__B2hEaQi4__"